export const summaryCardLevelsMapping = {
  L1: 0,
  L2: 1,
  L3: 2,
  L4: 3,
  L5: 4,
};
